import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MapLayersButton from './MapLayersButton'
import HelpButton from './HelpButton'
import MapHelpContent from './MapHelpContent'
import MapLayersContent from './MapLayersContent'
import MapLayerLegend from '../Legend/MapLayerLegend'
import { setLayersModalOpen, setHelpModalOpen, setLegendModalOpen } from '../../../ducks/mapControls'
import { handleModalVisibility, toggleModal } from '../../../common/util'
// import { AttributionControl } from 'react-map-gl/maplibre'
import { getHashState } from 'common/utils/hashUtils'
import { baseLayers } from '../Layers/thirdPartyLayers'

/**
 * This component serves as a container for the layer picker, legend, help, etc. and renders these controls on the map.
 *
 * @component
 * @returns {React.Element}
 */
const MapControlsContainer = () => {
  const dispatch = useDispatch()
  const isHelpModalOpen = useSelector(state => state.mapControls.helpModalOpen) || false
  const isLayersModalOpen = useSelector(state => state.mapControls.layersModalOpen)
  const isLegendModalOpen = useSelector(state => state.mapControls.legendModalOpen)
  const isWideScreen = window.innerWidth > 1165
  const isWideWaterfall = Boolean(document.querySelector('#mapbox.with-wide-waterfall'))
  const allowMultipleModals = isWideScreen && !isWideWaterfall
  const base = getHashState('base')
  let wordmarkClass = 'mapbox-wordmark hide'
  const [showStyleLegend, setShowStyleLegend] = useState(false)


  //only display mapbox wordmark with mapbox basemaps
  if(
    base &&
    baseLayers.some(
      (baseLayer) => baseLayer.id === base && baseLayer.vendor === 'mapbox'
    )
  ) {
    wordmarkClass = `mapbox-wordmark`
  }

  //zendesk chat behavior on map
  const [, setZExists] = useState(window.zE ? true : false)
  const chatInit = () => {
    if(window.zE) {
      window.zE('messenger:on', 'close', function() {
        window.zE('messenger', 'hide')
      })

      window.zE('messenger:on', 'open', function() {
        window.zE('messenger', 'show')
      })
      window.zE('messenger:on', 'unreadMessages', function (count) {
        console.log(`You have ${count} unread message(s).`)
        //let x = $('iframe[title="Number of unread messages"')[0]
        const x = document.querySelector('div[data-testid=\'unread-indicator-container\'')
        if(x) {
          x.style.display = 'none'
          debug('unread indicator hidden')
        } else {
          debug('no unread indicator found')
        }

        setTimeout(() => {
          const y = $('iframe[title="Number of unread messages"')[0]
          if(y) {
            y.style.display = 'none'
            debug('in timeout: unread indicator hidden')
          } else {
            debug('in timeout: no unread indicator found')
          }
        }, 100)
      })
    } else {
      debug('zE not loaded')
    }
  }

  useEffect(() => {
    const checkZExists = setInterval(() => {
      if(window.zE) {
        setZExists(true)
        chatInit()
        clearInterval(checkZExists)
      }
    }, 1000) // Check every second
    return () => clearInterval(checkZExists) // Clean up on component unmount
  }, [])

  const toggleHelpModal = () => {
    toggleModal({
      dispatch,
      isOpen:        isHelpModalOpen,
      setOpenAction: setHelpModalOpen,
      allowMultipleModals,
      handleModalVisibility,
      modalKey:      'helpModalOpen',
      keepAlso:      ['helpModalOpen'],
    })
  }

  const toggleLayersModal = () => {
    toggleModal({
      dispatch,
      isOpen:        isLayersModalOpen,
      setOpenAction: setLayersModalOpen,
      allowMultipleModals,
      handleModalVisibility,
      modalKey:      'layersModalOpen',
      keepAlso:      ['layersModalOpen'],
      afterToggle:   () => {
        //extras
        if(isLegendModalOpen) {
          dispatch(setLegendModalOpen(true))
        }
      },
    })
  }

  const toggleLegendModal = () => {
    toggleModal({
      dispatch,
      isOpen:        isLegendModalOpen,
      setOpenAction: setLegendModalOpen,
      allowMultipleModals,
      handleModalVisibility,
      modalKey:      'legendModalOpen',
      keepAlso:      ['layersModalOpen'],
      afterToggle:   (next) => {
        setShowStyleLegend(next)
      },
    })
  }
  useEffect(() => {
    setShowStyleLegend(!!isLegendModalOpen)
  }, [isLegendModalOpen])

  return (
    <div className="map-controls">
      <MapLayersButton
        isActive={isLayersModalOpen}
        toggleModal={toggleLayersModal}
      />
      <HelpButton
        isActive={isHelpModalOpen}
        toggleModal={toggleHelpModal}
      />
      {isLegendModalOpen && (
        <MapLayerLegend
          handleClose={toggleLegendModal}
         visible={showStyleLegend}
        />
      )}
      {isHelpModalOpen && <MapHelpContent handleClose={toggleHelpModal} />}
      {isLayersModalOpen && (
        <MapLayersContent
          showStyleLegend={showStyleLegend}
          setShowStyleLegend={setShowStyleLegend}
          handleClose={toggleLayersModal}
        />
      )}
      <a
        href="http://mapbox.com/about/maps"
        target="_blank"
        className={wordmarkClass} rel="noreferrer"
      ></a>
          </div>
  )
}

export default MapControlsContainer